$(function () {
	setupBreadcrumb(['Literature AI', 'Publications Overview'])

	// --- Tab activation from ?tab=genes|diseases|cooccurrence or hash ---
	const params = new URLSearchParams(window.location.search);
	const qp = (params.get('tab') || '').toLowerCase();
	const hash = (window.location.hash || '').replace('#', '').toLowerCase();

	const valid = ['genes','diseases','cooccurrence'];
	const target = valid.includes(qp) ? qp : (valid.includes(hash) ? hash : null);
	if (target) $('#' + target + '-tab').tab('show');

	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		const id = $(e.target).attr('id');
		if (id === 'genes-tab')        history.replaceState(null, '', '#genes');
		if (id === 'diseases-tab')     history.replaceState(null, '', '#diseases');
		if (id === 'cooccurrence-tab') history.replaceState(null, '', '#cooccurrence');
		$('.selectpicker').selectpicker('refresh');
	});

	// --- Gene Submit (static select) ---
	$('#pubGeneSubmit').on('click', function (e) {
		e.preventDefault();
		const gene = ($('#pubGeneSelect').val() || '').trim();
		if (gene) window.location.href = `/literature/gene/${gene}`;
		else renderWarn($('#alertPubGenes'), 'Please select a gene first.');
	});

	// ================================
	// ajax-bootstrap-select config + helpers (DISEASE)
	// ================================
	var DISEASE_ABS_BASE_CONFIG = {
		ajax: {
			url: '/literature/get_dropdown_diseases/',
			type: 'POST',
			dataType: 'json',
			data: { search_value: '{{{q}}}' },
			headers: { 'X-CSRFToken': getCsrf() }
		},
		minLength: 3,
		requestDelay: 300,
		preserveSelected: false,
		clearOnEmpty: true,
		bindEvent: 'keyup',
		preprocessData: function (resp) {
			var list = (resp && resp.disease_list) ? resp.disease_list : [];
			var out = [];
			for (var i = 0; i < list.length; i++) {
				var d = list[i];
				out.push({
					text: d.disease_name,
					value: d.id,
					data: { subtext: '(' + d.id_type + ')', tokens: d.id + ' ' + d.id_type }
				});
			}
			return out;
		}
	};

	function ensureBlankPlaceholder($sel) {
		if ($sel.find('option[value=""]').length === 0) $sel.prepend('<option value=""></option>');
		$sel.find('option').prop('selected', false);
		$sel.find('option[value=""]').prop('selected', true);
	}

	function setPickerPlaceholder($sel, text) {
		$sel.attr('title', text);
		$sel.attr('data-live-search-placeholder', text);
	}

	function clearPickerUI($sel) {
		$sel.selectpicker('val', '');
		var $search = $sel.parent().find('.bs-searchbox input');
		if ($search.length) $search.val('');
		$sel.selectpicker('render').selectpicker('refresh');
	}

	// Strong ABS teardown
	function destroyAbs($sel) {
		var abs = $sel.data('AjaxBootstrapSelect');
		if (abs && typeof abs.destroy === 'function') { try { abs.destroy(); } catch (e) {} }
		$sel.removeData('AjaxBootstrapSelect').removeData('ajaxbootstrapselect');
		$sel.off('.abs');
	}

	// NOTE: set title BEFORE selectpicker init so it’s picked up as the placeholder
	function initDiseaseAjax($sel, force, $helper) {
		destroyAbs($sel);
		if (force) {
			try { $sel.selectpicker('destroy'); } catch (e) {}
			$sel.empty();
		}

		// Default title first (fixes stale “associated with …” after Clear)
		setPickerPlaceholder($sel, 'Search Disease Name');

		ensureBlankPlaceholder($sel);
		if (!$sel.data('selectpicker')) $sel.selectpicker(); else $sel.selectpicker('render');

		var cfg = $.extend(true, {}, DISEASE_ABS_BASE_CONFIG);
		$sel.ajaxSelectPicker(cfg);
		if ($helper && $helper.length) $helper.show();
		clearPickerUI($sel);
	}

	function disableDiseaseAjax($sel, placeholder, $helper) {
		destroyAbs($sel); // keep selectpicker UI
		if (placeholder) setPickerPlaceholder($sel, placeholder);
		ensureBlankPlaceholder($sel);
		if ($helper && $helper.length) $helper.hide();
		clearPickerUI($sel);
	}

	// --- Diseases (AJAX) tab stand-alone ---
	const $disease = $('#pubDiseaseSelect');
	initDiseaseAjax($disease);

	$('#pubDiseaseSubmit').on('click', function (e) {
		e.preventDefault();
		const diseaseId = ($disease.val() || '').trim();
		if (diseaseId) window.location.href = `/literature/disease/${diseaseId}`;
		else renderWarn($('#alertPubDiseases'), 'Please select a disease first.');
	});

	// ================================
	// Co-occurrence wiring
	// ================================
	const $coocGene     = $('#coocGeneSelect');     // static list always
	const $coocDisease  = $('#coocDiseaseSelect');  // AJAX by default; static when Gene is first
	const $coocSubmit   = $('#coocSubmit');
	const $coocClear    = $('#coocClear');
	const $coocAlert    = $('#alertCooc');
	const $coocRow      = $('#coocFieldRow');
	const $coocGeneGroup = $('#coocGeneGroup');
	const $coocDiseaseGroup = $('#coocDiseaseGroup');
	const $coocDiseaseHelper = $('#coocDiseaseHelper');
	const $startGene = $('#coocStartGene');
	const $startDisease = $('#coocStartDisease');

	// Pristine gene list snapshot (with data-entrez)
	const originalGeneOptionsHtml = '<option value=""></option>' + $coocGene.html();

	// Start Co-oc Disease in AJAX mode
	initDiseaseAjax($coocDisease, /*force*/ true, $coocDiseaseHelper);

	// State
	let filterOwner = null; // 'gene' | 'disease' | null
	const coocState = { gene: '', geneEntrez: '', diseaseId: '' };
	let startWith = 'gene';

	// Guard for programmatic changes
	let suppressChanges = false;
	function withSuppressed(fn) { suppressChanges = true; try { fn(); } finally { suppressChanges = false; } }
	function toggleIfClosed($sel) {
		const $menu = $sel.parent().find('.dropdown-menu');
		if (!$menu.hasClass('show')) $sel.selectpicker('toggle');
	}

	// ---- Bind/unbind helpers ----
	function unbindCoocHandlers() { $coocGene.off('.cooc'); $coocDisease.off('.cooc'); }
	bindCoocHandlers(); // initial bind

	function reorderCoocFields(mode) {
		if (!$coocRow.length || !$coocGeneGroup.length || !$coocDiseaseGroup.length) return;
		if (mode === 'disease') {
			$coocRow.append($coocDiseaseGroup).append($coocGeneGroup);
		} else {
			$coocRow.append($coocGeneGroup).append($coocDiseaseGroup);
		}
	}

	function setStartWith(mode, reset) {
		if (startWith === mode) return;
		startWith = mode;
		if (mode === 'disease') {
			$startDisease.addClass('active');
			$startGene.removeClass('active');
			$startDisease.find('input').prop('checked', true);
			$startGene.find('input').prop('checked', false);
		} else {
			$startGene.addClass('active');
			$startDisease.removeClass('active');
			$startGene.find('input').prop('checked', true);
			$startDisease.find('input').prop('checked', false);
		}
		reorderCoocFields(mode);
		if (reset) resetCooc(true);
	}

	function resetCooc(forceResetTitles) {
		withSuppressed(function () {
			unbindCoocHandlers();

			$coocGene.html(originalGeneOptionsHtml);
			if (!$coocGene.data('selectpicker')) $coocGene.selectpicker(); else $coocGene.selectpicker('render');
			setPickerPlaceholder($coocGene, 'Search Gene Symbol');
			$coocGene.selectpicker('refresh');
			clearPickerUI($coocGene);
			coocState.gene = '';
			coocState.geneEntrez = '';

			setPickerPlaceholder($coocDisease, 'Search Disease Name');
			initDiseaseAjax($coocDisease, /*force*/ true, $coocDiseaseHelper);
			clearPickerUI($coocDisease);
			coocState.diseaseId = '';

			filterOwner = null;

			bindCoocHandlers();
		});

		updateCoocUi(forceResetTitles);
	}

	function bindCoocHandlers() {
		// Gene changed (static)
		$coocGene.on('changed.bs.select.cooc', function () {
			if (suppressChanges) return;

			const gene   = ($coocGene.val() || '').trim();
			const entrez = ($coocGene.find('option:selected').data('entrez') || '').toString().trim();

			coocState.gene = gene;
			coocState.geneEntrez = entrez;

			// Cleared gene
			if (!gene) {
				if (filterOwner === 'gene') {
					withSuppressed(function () {
						coocState.diseaseId = '';
						initDiseaseAjax($coocDisease, /*force*/ true, $coocDiseaseHelper); // sets default title before init
						clearPickerUI($coocDisease);
					});
					filterOwner = null;
				}
				updateCoocUi();
				return;
			}

			// Set owner if none
			if (!filterOwner) filterOwner = 'gene';

			// Gene-first filters Disease (switch Disease to STATIC filtered)
			if (filterOwner === 'gene') {
				if (!entrez) {
					renderWarn($coocAlert, 'Selected gene is missing Entrez ID; cannot filter diseases.');
					updateCoocUi();
					return;
				}
				withSuppressed(function () {
					disableDiseaseAjax($coocDisease, 'Diseases Associated with ' + gene, $coocDiseaseHelper);
					$coocDisease.empty();
					ensureBlankPlaceholder($coocDisease);
					setPickerPlaceholder($coocDisease, 'Diseases Associated with ' + gene);
					$coocDisease.selectpicker('refresh');
					clearPickerUI($coocDisease);
				});
				loadAssociatedDiseases(entrez)
					.done(function (list) {
						fillDiseaseOptions($coocDisease, list, /*addBlank*/ true);
						setPickerPlaceholder($coocDisease, 'Diseases Associated with ' + gene);
						$coocDisease.selectpicker('refresh');
						updateCoocUi();
						setTimeout(function () { toggleIfClosed($coocDisease); }, 0);
					})
					.fail(function () { renderWarn($coocAlert, 'Failed to load associated diseases. Please try again.'); });
			}

			updateCoocUi();
		});

		// Disease changed (AJAX by default)
		$coocDisease.on('changed.bs.select.cooc', function () {
			if (suppressChanges) return;

			const diseaseId = ($coocDisease.val() || '').trim();
			coocState.diseaseId = diseaseId;

			// Cleared disease
			if (!diseaseId) {
				if (filterOwner === 'disease') {
					withSuppressed(function () {
						$coocGene.html(originalGeneOptionsHtml);
						if (!$coocGene.data('selectpicker')) $coocGene.selectpicker();
						clearPickerUI($coocGene);
						coocState.gene = '';
						coocState.geneEntrez = '';
					});
					filterOwner = null;
				}
				updateCoocUi();
				return;
			}

			// Set owner if none
			if (!filterOwner) filterOwner = 'disease';

			// Disease-first filters Gene (static swap)
			if (filterOwner === 'disease') {
				withSuppressed(function () {
					$coocGene.empty();
					ensureBlankPlaceholder($coocGene);
					if (!$coocGene.data('selectpicker')) $coocGene.selectpicker();
					clearPickerUI($coocGene);
					coocState.gene = '';
					coocState.geneEntrez = '';
				});
				loadAssociatedGenes(diseaseId)
					.done(function (list) {
						fillGeneOptions($coocGene, list, /*addBlank*/ true);
						updateCoocUi();
						setTimeout(function () { toggleIfClosed($coocGene); }, 0);
					})
					.fail(function () { renderWarn($coocAlert, 'Failed to load associated genes. Please try again.'); });
			}

			updateCoocUi();
		});
	}

	// Submit co-occurrence
	$coocSubmit.on('click', function (e) {
		e.preventDefault();
		if (coocState.gene && coocState.diseaseId) {
			window.location.href = `/literature/cooccurrence/${coocState.gene}/${coocState.diseaseId}`;
		} else {
			renderWarn($coocAlert, 'Please select both a gene and a disease.');
		}
	});

	// Clear both → reset to initial state (Gene full static, Disease live AJAX)
	$coocClear.on('click', function (e) {
		e.preventDefault();
		resetCooc(true);
	});

	function updateCoocUi(resetTitles) {
		if (coocState.gene && coocState.diseaseId) {
			$coocSubmit.removeClass('disabled').attr('aria-disabled', 'false');
		} else {
			$coocSubmit.addClass('disabled').attr('aria-disabled', 'true');
		}

		if (resetTitles) {
			setPickerPlaceholder($coocGene, 'Search Gene Symbol');
			setPickerPlaceholder($coocDisease, 'Search Disease Name');
			$coocGene.selectpicker('refresh');
			$coocDisease.selectpicker('refresh');
			return;
		}

		if (filterOwner === 'gene' && coocState.gene && !coocState.diseaseId) {
			setPickerPlaceholder($coocDisease, 'Diseases Associated with ' + coocState.gene);
			$coocDisease.selectpicker('refresh');
		} else if (filterOwner === 'disease' && coocState.diseaseId && !coocState.gene) {
			setPickerPlaceholder($coocGene, 'Select a Gene Associated with the Chosen Disease');
			$coocGene.selectpicker('refresh');
		} else {
			setPickerPlaceholder($coocGene, 'Search Gene Symbol');
			setPickerPlaceholder($coocDisease, 'Search Disease Name');
			$coocGene.selectpicker('refresh');
			$coocDisease.selectpicker('refresh');
		}
	}

	$startGene.off('.coocStart').on('click.coocStart', function () {
		setStartWith('gene', /*reset*/ true);
	});
	$startDisease.off('.coocStart').on('click.coocStart', function () {
		setStartWith('disease', /*reset*/ true);
	});

	reorderCoocFields(startWith);

	// ---- Fillers ----
	function fillDiseaseOptions($sel, list, addBlank) {
		withSuppressed(() => {
			$sel.empty();
			if (addBlank) $sel.append('<option value=""></option>');
			for (let i = 0; i < list.length; i++) {
				const d = list[i];
				$sel.append(
					`<option value="${d.id}" data-subtext="(${d.id_type})" data-tokens="${d.id} ${d.id_type}">${escapeHtml(d.disease_name)}</option>`
				);
			}
			clearPickerUI($sel);
		});
	}

	function fillGeneOptions($sel, list, addBlank) {
		withSuppressed(() => {
			$sel.empty();
			if (addBlank) $sel.append('<option value=""></option>');
			for (let i = 0; i < list.length; i++) {
				const g = list[i];
				$sel.append(
					`<option value="${escapeAttr(g.gene_symbol)}" data-entrez="${escapeAttr(g.entrez_gene_id || '')}">${escapeHtml(g.gene_symbol)}</option>`
				);
			}
			clearPickerUI($sel);
		});
	}

	// ---- API calls ----
	function loadAssociatedDiseases(geneEntrezId) {
		return $.ajax({
			url: '/literature/get_associated_diseases/',
			type: 'POST',
			dataType: 'json',
			data: { gene_id: geneEntrezId },
			headers: { 'X-CSRFToken': getCsrf() }
		}).then(function (resp) { return (resp && resp.disease_list) ? resp.disease_list : []; });
	}

	function loadAssociatedGenes(diseaseId) {
		return $.ajax({
			url: '/literature/get_associated_genes/',
			type: 'POST',
			dataType: 'json',
			data: { disease_id: diseaseId },
			headers: { 'X-CSRFToken': getCsrf() }
		}).then(function (resp) { return (resp && resp.genes_list) ? resp.genes_list : []; });
	}

	// Smooth-scroll chevrons
	scrollToElement('#public-databases-top', '#top-header');
	scrollToElement('#literature-curated-top', '#top-header');
	scrollToElement('#literature-mined-top',  '#top-header');
});

// ===== Shared helpers you already had =====
function renderWarn($container, msg) {
	if (!$container || !$container.length) return;
	$container.html(
		'<div class="alert alert-warning alert-dismissible fade show" role="alert">'
		+ msg +
		'<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
		+ '<span aria-hidden="true">&times;</span>'
		+ '</button>'
		+ '</div>'
	);
}

function getCsrf() {
	const fromInput = $('input[name="csrfmiddlewaretoken"]').val();
	if (fromInput) return fromInput;
	const m = document.cookie.match(/(?:^|;)\s*csrftoken=([^;]+)/);
	return m ? decodeURIComponent(m[1]) : '';
}

function scrollToElement(sourceId, targetId) {
	$(sourceId).click(() => { $.scrollTo($(targetId), 500, { offset: -180 }); });
}

// Minimal escaping to avoid HTML injection when building options
function escapeHtml(str) {
	return String(str).replace(/[&<>"']/g, function (m) {
		return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]);
	});
}
function escapeAttr(str) { return escapeHtml(str).replace(/"/g, '&quot;'); }
